import React from "react";


const FounderProfile = () => {
  return (
    <div className="container my-5">
      <h1>Notre équipe</h1>
      <h2 className="mb-3">
        Une vision fondée sur le partenariat, l’expérience, et les résultats
      </h2>

      <p className="fw-bold">
        👤 Moez Ben Zid – <span className="fst-italic">Fondateur</span>
      </p>

      <p>
        Moez cumule plus de 25 ans d’expérience internationale dans le secteur
        des services financiers, aux États-Unis, en Europe, au Moyen-Orient, en
        Afrique et en Asie. Il a occupé des postes de direction au sein
        d’institutions de premier plan telles que <strong> JPMorgan, Merrill Lynch et
        Deutsche Bank.</strong>
      </p>

      <p>Son expertise couvre un large éventail de domaines :</p>
      <ul>
        <li>Fusions & Acquisitions</li>
        <li>Conseil stratégique et en gestion des risques</li>
        <li>Gestion du capital humain</li>
        <li>Transformation digitale</li>
        <li>Gestion de projets et de programmes</li>
      </ul>

      <p>
        Moez possède également une connaissance approfondie des marchés
        financiers et des instruments, notamment les <strong>dérivés, produits
        structurés, capital-investissement, investissements alternatifs et
        matières premières.</strong>
      </p>
    </div>
  );
};

export default FounderProfile;
